import { createStore, createLogger } from 'vuex'
import { Modifier, ParamData, RootStateInterface } from './rootStateInterface'
import * as TYPES from './types'
import Cookies from 'js-cookie'
const debug = process.env.NODE_ENV !== 'production'
export default createStore<RootStateInterface>({
  state: {
    token: '',
    userName: '',
    userInfo: '',
    modifier: undefined,
    paramData: undefined,
  },
  getters: {
    getToken: (state) => {
      return state.token = Cookies.get('token')
    },
    getUserName: (state) => {
      return state.userName = Cookies.get('username')
    },
    getUserId: (state) => {
      return state.userInfo.user_id = Cookies.get('user_id')
    },
  },
  mutations: {
    // 登陆成功存储token
    [TYPES.SET_TOKEN](state, token: string) {
      state.token = token;
      // Cookies.set('token', state.token, {
      //   domain: '192.168.115.235',
      //   path: '/'
      // })
      Cookies.set('token', state.token)
    },
    // 退出登录
    [TYPES.OUT_LOGIN](state) {
      state.token = '';
      state.userName = '';
      Cookies.remove('token')
      Cookies.remove('username')
      Cookies.remove('user_id')
    },
    // 用户信息
    [TYPES.SET_USERINFO](state, userInfo: any) {
      state.userInfo = userInfo;
      Cookies.set('user_id',state.userInfo.user_id)
    },
    [TYPES.SET_MODIFIER](state, modifier?: Modifier) {
      state.modifier = modifier;
    },
    [TYPES.SET_PARAMDATA](state, paramData?: ParamData) {
      state.paramData = paramData;
    },
  },
  actions: {
  },
  modules: {
  },
  plugins: debug ? [createLogger()] : []
})